module.exports = __webpack_public_path__ + "static/media/Loading_Bar_Fill@3x.b63f799e.png";